import React from 'react';
import PropTypes from 'prop-types';
import SchoolLogo from './SchoolLogo';
import poweredBy from '../../ASUPhotos/logos/poweredBy.png';
import mcfLogo from '../../BaobabPhotos/logos/Baobab_MCF_Logo_FullColor.svg';

const PoweredBy = ({ tenant }) => (
  <div className="powered-by-container">
    {/* keeping this here because we can use this to style landing for future tenants */}
    {!!tenant && tenant.name !== 'ASU' && tenant.name !== 'InStride' ? (
      <SchoolLogo
        schoolLogoWidth={tenant.name === 'Baobab' ? '55px' : '100%'}
        schoolLogoPadding="0"
        horizontalAlign="center"
        containerJustify="center"
        schoolLogoContainerWidth="100%"
        poweredByLogoExists={tenant.name === 'Baobab' ? mcfLogo : tenant.logo}
        containerMargin="0"
      />
    ) : null}
    <a
      className="powered-by"
      href="https://www.asu.edu/"
      target="_blank"
      rel="noopener noreferrer"
    >
      {/* <img src={poweredBy} alt="Powered By Arizona State University" /> */}
      <picture>
        <source
          media="(max-width: 799px)"
          srcSet={poweredBy}
          width="480"
          height="400"
        />
        <source
          media="(min-width: 800px)"
          srcSet={poweredBy}
          width="800"
          height="400"
        />
        <img
          src={poweredBy}
          alt="Powered By Arizona State University"
          width="800"
          height="400"
        />
      </picture>
    </a>
  </div>
);

export default PoweredBy;

PoweredBy.propTypes = {
  tenant: PropTypes.object.isRequired,
};
